export async function validateSupportToken(id, token) {
  if (!id || !token) return 0;

  try {
    const rsp = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/support/validate`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, token }),
      }
    );
    return rsp.status;
  } catch {
    return 0;
  }
}
